import { useLocalization } from "../../../context/LocalizationContext";
import "./BrowserUnsupported.css";

const BROWSERS = [
  {
    name: "Google Chrome",
    url: "https://www.google.com/chrome/",
    icon: (
      <svg viewBox="0 0 48 48" className="browser-icon" aria-hidden="true">
        <circle cx="24" cy="24" r="24" fill="#fff" />
        <circle cx="24" cy="24" r="10" fill="#4285F4" />
        <path d="M24 14h18.2A24 24 0 0 0 5.8 14z" fill="#EA4335" />
        <path d="M5.8 14A24 24 0 0 0 13.9 42l9-15.6A10 10 0 0 1 14 24z" fill="#FBBC05" />
        <path d="M42.2 14H24a10 10 0 0 1 0 20l-9 15.6A24 24 0 0 0 42.2 14z" fill="#34A853" />
        <circle cx="24" cy="24" r="6" fill="#4285F4" />
      </svg>
    ),
  },
  {
    name: "Microsoft Edge",
    url: "https://www.microsoft.com/edge",
    icon: (
      <svg viewBox="0 0 48 48" className="browser-icon" aria-hidden="true">
        <circle cx="24" cy="24" r="24" fill="#fff" />
        <path
          d="M38 26c0 8-6.3 14-14 14a14 14 0 0 1-11.6-6.2c2.1 1.4 4.6 2.2 7.3 2.2 5.5 0 10-3.8 10-8.5C29.7 22 25.7 19 21 19c-1 0-2 .1-2.9.3C20.5 12.6 27 8 34.5 8A14 14 0 0 1 38 26z"
          fill="#0078D7"
        />
        <path
          d="M10 28.5C10 20.4 16.5 14 24.5 14c1.4 0 2.7.2 4 .5C26.3 12.3 23.4 11 20 11c-7.7 0-14 6.3-14 14 0 3.3 1.1 6.3 3 8.7A14 14 0 0 0 10 28.5z"
          fill="#00B4F0"
        />
      </svg>
    ),
  },
];

const BrowserUnsupported = () => {
  const { t } = useLocalization();

  return (
    <div className="browser-unsupported-overlay" role="alert" aria-live="assertive">
      <div className="browser-unsupported-card">
        <div className="browser-unsupported-icon-wrap">
          <svg viewBox="0 0 24 24" fill="none" className="browser-unsupported-warning-icon" aria-hidden="true">
            <path
              d="M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2zm0 11a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1zm1 4h-2v-2h2v2z"
              fill="currentColor"
            />
          </svg>
        </div>

        <h1 className="browser-unsupported-title">{t("browserUnsupported.title")}</h1>
        <p className="browser-unsupported-subtitle">{t("browserUnsupported.subtitle")}</p>
        <p className="browser-unsupported-description">{t("browserUnsupported.description")}</p>

        <div className="browser-unsupported-divider" />

        <p className="browser-unsupported-suggestion">{t("browserUnsupported.suggestion")}</p>
        <div className="browser-unsupported-browsers">
          {BROWSERS.map((browser) => (
            <a
              key={browser.name}
              href={browser.url}
              target="_blank"
              rel="noopener noreferrer"
              className="browser-unsupported-browser-link"
            >
              {browser.icon}
              <span>{browser.name}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrowserUnsupported;
